import { setTerm } from './helpers';

export const setVillageMortgageAllowed = setTerm('village_mortgage_allowed');
